import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams, Events } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { HomePage } from "../home/home";
import { EsqueciPage } from "../esqueci/esqueci";

import { CadastroPage } from "../cadastro/cadastro";

import { Http } from "@angular/http";

import config from "../../config/config";
import { RecadastramentoPage } from "../recadastramento/recadastramento";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-login",
  templateUrl: "login.html"
})
export class LoginPage {
  form = {};
  token: String = sessionStorage.getItem("token");
  id: String = sessionStorage.getItem("id");

  constructor(
    public navCtrl: NavController,
    private _http: Http,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public event: Events,
    public navParams: NavParams
  ) {}

  ionViewDidLoad() {
    if (this.token) {
      this.navCtrl.setRoot(HomePage);
    }
  }
  login(form) {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();

    this._http
      .post(config.urlAPI + "login", form,{})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        loading.dismiss();
        sessionStorage.setItem("token", res.token);
        sessionStorage.setItem("id", res.usuario.id);
        this.navCtrl.setRoot(HomePage);
        this.event.publish('atualizar',{})
        
      })
      .catch(error => {
        console.log(error);
        loading.dismiss();

        let alert = this.alertCtrl.create({
          title: "Login não Autorizado",
          subTitle: "Usuário e/ou senha não cadastrados",
          buttons: ["ok"]
        });
        alert.present();
      });
  }
  criarConta() {
    this.navCtrl.setRoot(CadastroPage);
  }
  EsqueciConta() {
    this.navCtrl.setRoot(EsqueciPage);
  }
  EsqueciConta2() {
    this.navCtrl.push(EsqueciPage, {
      esqueci: true
    });
  }
  recadastrar() {
    this.navCtrl.setRoot(RecadastramentoPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts